<template>
    <div class="custom-dropdown btn-group" :class="showMenu ? className + ' open' : className + ' closed'">
        <li @click="toggleMenu()" class="dropdown-toggle" v-if="selectedOption.name !== undefined">
            {{ selectedOption.name }}
        </li>

        <li @click="toggleMenu()" class="dropdown-toggle" v-if="selectedOption.name === undefined">
            {{placeholderText}}
        </li>

        <ul class="dropdown-menu" v-if="showMenu">
            <li v-for="(option, i) in options" :key="i">
                <a href="javascript:void(0)" @click="updateOption(option)" :class="{disabled: option.disabled }">
                    <!-- This disabled thing is here because this component is used as a date dropdown and we needed
                    a way to disable certain dates if they were unavailable -->
                    {{ option.name }} <span v-if="option.disabled" class="disabled-indicator">Utsolgt</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<style scoped>
    .disabled {
        pointer-events: none;
        cursor: pointer;
        opacity: .5;
    }

    .disabled-indicator {
        color: red;
        opacity: 1;
        font-weight: bold;
        margin-left: 5px;
    }
</style>

<script>
    export default {
        data() {
            return {
                selectedOption: {
                    name: '',
                },
                showMenu: false,
                placeholderText: 'Please select an item',
            }
        },
        props: {
            options: {
                type: [Array, Object]
            },
            selected: {},
            placeholder: [String],
            closeOnOutsideClick: {
                type: [Boolean],
                default: true,
            },
            className: [String]
        },

        mounted() {
            this.selectedOption = this.selected;
            if (this.placeholder) {
                this.placeholderText = this.placeholder;
            }

            if (this.closeOnOutsideClick) {
                document.addEventListener('click', this.clickHandler);
            }
        },

        beforeDestroy() {
            document.removeEventListener('click', this.clickHandler);
        },

        watch: {
            selected(val) {
                this.selectedOption = val;
            }
        },

        methods: {
            updateOption(option) {
                this.selectedOption = option;
                this.showMenu = false;
                this.$emit('updateOption', this.selectedOption);
            },

            toggleMenu() {
                this.showMenu = !this.showMenu;
            },

            clickHandler(event) {
                const {target} = event;
                const {$el} = this;

                if (!$el.contains(target)) {
                    this.showMenu = false;
                }
            },
        }
    }
</script>
